/* ARRAY - THE EVERYDAY EDIT.  One button: add the whole edit.

   The section is otherwise static - four links and four prices rendered by
   Liquid - so this file exists only to put the four variants in the cart in a
   single request and to tell Horizon about it.

   IT ADDS ONLY THE VARIANTS THE SECTION SAID WERE AVAILABLE. The id list is
   built in Liquid from `available` variants and the button's total is the sum
   of exactly those, so the number on the pill is always the number that lands
   in the cart. If a shade sells out, that product drops out of both at the next
   page render rather than the whole add failing at checkout.

   ONE REQUEST, NOT FOUR. /cart/add.js takes an items array; four separate
   POSTs would race each other for the cart's lock and can return a stale
   count for the header bubble.

   THE cart:update CONTRACT IS COPIED FROM beyondads-bag.js so the two behave
   identically: ask for the cart-items sections by id in the POST body, then
   hand the markup Shopify returns back as detail.data.sections. Skip that and
   the header count does not move until the next page load.
*/
(function () {
  'use strict';

  function sectionIds() {
    var ids = [], c = document.querySelectorAll('cart-items-component'), i;
    for (i = 0; i < c.length; i++) {
      if (c[i].dataset && c[i].dataset.sectionId) ids.push(c[i].dataset.sectionId);
    }
    return ids;
  }

  function announce(count, sections) {
    var ev;
    try {
      ev = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: 'beyondads-edit',
          data: {
            source: 'product-form-component',
            itemCount: count,
            sections: sections || {}
          }
        }
      });
    } catch (e) { return; }
    document.dispatchEvent(ev);
  }

  function addAll(btn) {
    if (btn.disabled || btn.__busy) return;
    var raw = (btn.getAttribute('data-ids') || '').split(',');
    var items = [], i, n;
    for (i = 0; i < raw.length; i++) {
      n = parseInt(raw[i], 10);
      if (n) items.push({ id: n, quantity: 1 });
    }
    if (!items.length) return;

    btn.__busy = true;
    btn.classList.add('is-busy');

    var label = btn.querySelector('[data-dh-label]');
    var was = label ? label.textContent : '';

    var body = { items: items };
    var ids = sectionIds();
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res || res.status >= 400 || res.errors) {
          if (label) label.textContent = 'Not available';
          setTimeout(function () {
            if (label) label.textContent = was;
            btn.__busy = false;
          }, 1800);
          return;
        }
        btn.classList.add('is-done');
        if (label) label.textContent = 'Added';
        announce(items.length, res.sections);
        setTimeout(function () {
          btn.classList.remove('is-done');
          if (label) label.textContent = was;
          btn.__busy = false;
        }, 1900);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.__busy = false;
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-dh-all]');
    if (!btn) return;
    e.preventDefault();
    addAll(btn);
  });
})();
